exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proposal-settings-tab-div .custom-tabs-pg-settings .nav-link.active,\n#proposal-settings-tab-div .custom-tabs-pg-settings .nav-link:hover,\n#proposal-settings-tab-div .custom-tabs-pg-settings .nav-link:focus {\n  background-color: #fff !important;\n  border-bottom-color: transparent !important;\n  color: #555;\n}\n#proposal-settings-tab-content {\n  padding: 15px;\n  border: 1px solid #c7cdd1;\n  border-top: 0;\n  border-radius: 0 0 5px 5px;\n  min-height: 60vh;\n  background: #fff;\n}\n#proposal-settings-tab-div .nav-item a {\n  font-weight: 300;\n}\n.proposal-setting-back-arrow {\n  width: 20px;\n}\n", ""]);

// exports
